const stringToColor = string => {
  switch (string) {
    case "Heather":
      return "#8c8d8f"
      break
    case "Heather Grey":
      return "#8c8d8f"
      break
    case "Heather Gray":
      return "#8c8d8f"
      break
    default:
      return string.toLowerCase()
  }
}

export { stringToColor }
